import { useState } from 'react';
import { Control, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AlertSuccessIcon,
  Circle,
  HStack,
  Text,
} from '@cdl/heartbeat-react';
import { DropdownAnnotators } from './dropdown/DropdownAnnotators';
import { Annotator } from '../../../ecg/types/annotation-tasks.type';
import { FormValues } from '../../types/annotation-task-detail.type';
import { ClearButton } from './ClearButton';

type Props = {
  register: UseFormRegister<FormValues>;
  setValue: UseFormSetValue<FormValues>;
  control: Control<FormValues>;
};

export const AnnotatorsForm: React.FC<Props> = ({
  register,
  setValue,
  control,
}) => {
  const [selectedAnnotators, setSelectedAnnotators] = useState<Annotator[]>([]);

  const handleAnnotatorsChange = (values: Annotator[]) => {
    setSelectedAnnotators(values);
    setValue('annotators', values, { shouldValidate: true });
  };

  const clearAllData = () => {
    setSelectedAnnotators([]);
    setValue('annotators', [], { shouldValidate: true });
  };

  return (
    <Accordion defaultIndex={[0]} allowMultiple>
      <AccordionItem bgColor='white'>
        <AccordionButton
          justifyContent='space-between'
          p='l'
          borderBottom='1px'
          borderColor='neutral.100'
        >
          <HStack gap={2}>
            {selectedAnnotators.length > 0 ? (
              <AlertSuccessIcon size='s' color='green.400' m='s' />
            ) : (
              <Circle size='16px' m='s' border='1px' />
            )}
            <Text textStyle='page-subtitle' as='span'>
              Annotators*
            </Text>
            {selectedAnnotators.length > 0 ? (
              <HStack pl='xl' color='neutral.300'>
                <Text>Annotators ({selectedAnnotators.length}) :</Text>
                {selectedAnnotators.map((annotator) => (
                  <Text key={annotator.id}>{annotator.name}</Text>
                ))}
              </HStack>
            ) : (
              <Text pl='xl' color='neutral.300'>
                No information set
              </Text>
            )}
          </HStack>
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel p='xl' h='auto'>
          <DropdownAnnotators
            selectedData={selectedAnnotators}
            handleDataChange={handleAnnotatorsChange}
            register={register}
            control={control}
          />
          <ClearButton clearAllData={clearAllData} />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
